/* List of Redux constants */
export const CANDIDATE_REFERENCES_SET_LOADING = '@candidate-references/set-loading';
export const CANDIDATE_REFERENCES_SET_REFERENCES = '@candidate-references/set-references';
export const CANDIDATE_REFERENCES_SET_DISPLAY_NEW_REQUEST_FORM = '@candidate-references/set-display-new-request-form';
export const CANDIDATE_REFERENCES_SET_COUNT_LIMIT_REACHED = '@candidate-references/set-references-count-limit-reached';
export const CANDIDATE_REFERENCES_RESET = '@candidate-references/reset';
export const CANDIDATE_REFERENCES_SET_NOT_ENOUGH_REFERENCES_TO_APPLY = '@candidate-references/set-not-enough-references-to-apply';
export const CANDIDATE_REFERENCES_SET_SUBMIT_NEW_CANDIDATE_REFERENCE_REQUEST_ERROR = '@candidate-references/set-submit-new-candidate-reference-request-error';
export const CANDIDATE_REFERENCES_RESET_SUBMIT_NEW_CANDIDATE_REFERENCE_REQUEST_ERROR = '@candidate-references/reset-submit-new-candidate-reference-request-error';

/* List of Sagas constants */
export const CANDIDATE_REFERENCES_GET_REFERENCES = '@candidate-references/get-references';
export const CANDIDATE_REFERENCES_SUBMIT_NEW_CANDIDATE_REFERENCE_REQUEST = '@candidate-references/submit-new-candidate-reference-request';
export const CANDIDATE_REFERENCES_RESEND_NOTIFICATION = '@candidate-references/resend-notification';
export const CANDIDATE_REFERENCES_REMOVE_CANDIDATE_REFERENCES = '@candidate-references/remove-candidate-reference';




// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-references/types.js